import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  IconButton,
} from "@mui/material";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { GMB } from "../../../services/gmbApiConfig";

const CreateModal = ({ setCreate }) => {
  const [dropdowndata, setDropdowndata] = useState([]);
  const [projectname, setProjectname] = useState("");
  const [issuetype, setIssuetype] = useState("");
  const [summary, setSummary] = useState("");
  const [description, setDescription] = useState("");
  const [developmentby, setDevelopmentby] = useState("");
  const [uatby, setUatby] = useState("");
  const [migartionby, setMigartionby] = useState("");
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);

  const handleFileSelect = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    console.log(file);
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleChangeProject = (event) => {
    setProjectname(event.target.value);
  };
  const handleChangeIssue = (event) => {
    setIssuetype(event.target.value);
  };
  const handleInputChange = (event) => {
    setSummary(event.target.value);
  };
  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };
  const handleDevelopmentBy = (event) => {
    setDevelopmentby(event.target.value);
  };
  const handleUATBy = (event) => {
    setUatby(event.target.value);
  };
  const handleMigrationBy = (event) => {
    setMigartionby(event.target.value);
  };

  const fetchData = async () => {
    try {
      const response = await axios.post(
        `https://cqslmlqa6kdef2jyswlz5vtl4y0eoova.lambda-url.ap-south-1.on.aws/get_create_project_dropdowns`,
        { domain_id: Cookies.get("ssp_domain_id") },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response.data?.status === "error") {
        toast.error("Failed to fetch store accounts");
      }
      setDropdowndata(response?.data?.data);
    } catch (error) {
      toast.error("Failed to fetch store accounts");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmitRequest = async () => {
    try {
      if (summary == "" || description == "" || fileName == "" || migartionby == "" || developmentby == "" || uatby == "") {
        toast.error("Please enter all the fields");
        return;
      }
      else if(developmentby == migartionby){
        toast.error("Development and migration can only be completed by separate developers");
        return;
      }
      const response = await axios.post(
        `https://cqslmlqa6kdef2jyswlz5vtl4y0eoova.lambda-url.ap-south-1.on.aws/get_upload_post_url`,
        { file_name: fileName },
        {
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.body?.url) {
        const fileUploadData = new FormData();
        Object.keys(response?.data?.body?.fields).forEach((key) => {
          fileUploadData.append(key, response?.data?.body?.fields[key]);
        });
        fileUploadData.append("file", file);
        fileUploadData.forEach((value, key) => {
          console.log(`${key}: ${value}`);
        });
        const fileUploaded = await axios.post(
          response?.data?.body?.url,
          fileUploadData
        );
        const responseCreateData = await axios.post(
          `https://cqslmlqa6kdef2jyswlz5vtl4y0eoova.lambda-url.ap-south-1.on.aws/create_task`,
          {
            project: projectname,
            issue_type: issuetype,
            summary: summary,
            description: description,
            development_by: developmentby,
            uat_by: uatby,
            migration_by: migartionby,
            create_id: Cookies.get("ssp_domain_id"),
            modify_id: Cookies.get("ssp_domain_id"),
            file_name: response?.data?.file_name,
            domain_id: Cookies.get("ssp_domain_id"),
            role: parseInt(Cookies.get("ssp_role"),10),
            project_id: response?.data?.project_id
          },
          {
            headers: {
              Authorization: Cookies.get("ssp_sso_token"),
              "content-type": "application/json",
            },
          }
        );
        if (responseCreateData?.data?.status == "error") {
          toast.error("Task Created Failed");
        } else if (responseCreateData?.data?.status == "success") {
          toast.success("Task Created Successfully");
          setCreate(false);
          window.location.reload();
        }
      }
    } catch (error) {
      toast.error("Failed to Create Task");
    }
  };

  return (
    <>
      <Typography
        sx={{
          fontSize: 20,
          fontWeight: 600,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        Create
      </Typography>
      <Typography
        sx={{
          fontSize: 15,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        All fields are mandatory
      </Typography>
      <br />
      <Grid
        container
        spacing={1}
        alignItems="flex-start"
        direction="column"
        sx={{ justifyContent: "flex-start" }}
      >
        <Grid item xs={2} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            sx={{
              fontSize: 15,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            Project
          </Typography>
          <FormControl
            sx={{
              maxWidth: 300,
              minWidth: 300,
              marginTop: 1,
              marginBottom: 1,
            }}
          >
            <Select
              displayEmpty
              size="small"
              sx={{ fontSize: 15, textAlign: "left" }}
              value={projectname}
              onChange={handleChangeProject}
            >
              <MenuItem value="">
                <em>Select Project</em>
              </MenuItem>
              {Array.isArray(dropdowndata?.project) &&
                dropdowndata?.project.map((option) => (
                  <MenuItem key={option} value={option} sx={{ fontSize: 15 }}>
                    {option}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            sx={{
              fontSize: 15,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            Request Type
          </Typography>
          <FormControl
            sx={{
              maxWidth: 300,
              minWidth: 300,
              marginTop: 1,
              marginBottom: 1,
            }}
          >
            <Select
              displayEmpty
              size="small"
              sx={{ fontSize: 15, textAlign: "left" }}
              value={issuetype}
              onChange={handleChangeIssue}
            >
              <MenuItem value="">
                <em>Select Request type</em>
              </MenuItem>
              {Array.isArray(dropdowndata?.issue_type) &&
                dropdowndata?.issue_type.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Typography
        sx={{
          fontSize: 15,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        Summary
      </Typography>
      <textarea
        rows={2}
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          border: "1px solid black",
          marginTop: "0.5rem",
          width: "95%",
          fontSize: 15,
          fontFamily: 'Arial, sans-serif',
          paddingLeft: '5px'
        }}
        value={summary}
        onChange={handleInputChange}
      />
      <Typography
        sx={{
          fontSize: 15,
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          marginTop: "0.5rem",
        }}
      >
        Description
      </Typography>
      <textarea
        rows={3}
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          border: "1px solid black",
          marginTop: "0.5rem",
          width: "95%",
          fontSize: 15,
          fontFamily: 'Arial, sans-serif',
          paddingLeft: '5px'
        }}
        value={description}
        onChange={handleDescriptionChange}
      />
      <Grid
        container
        spacing={1}
        alignItems="flex-start"
        direction="column"
        sx={{ justifyContent: "flex-start" }}
      >
        <Grid item xs={2} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            sx={{
              fontSize: 15,
              marginTop: "0.5rem",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            Development By
          </Typography>
          <FormControl
            sx={{
              maxWidth: 300,
              minWidth: 300,
              marginTop: 1,
              marginBottom: 1,
            }}
          >
            <Select
              displayEmpty
              size="small"
              sx={{ fontSize: 15, textAlign: "left" }}
              value={developmentby}
              onChange={handleDevelopmentBy}
            >
              <MenuItem value="">
                <em>Select Name</em>
              </MenuItem>
              {Array.isArray(dropdowndata?.developers) &&
                dropdowndata?.developers.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            sx={{
              fontSize: 15,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            UAT By
          </Typography>
          <FormControl
            sx={{
              maxWidth: 300,
              minWidth: 300,
              marginTop: 1,
              marginBottom: 1,
            }}
          >
            <Select
              displayEmpty
              size="small"
              sx={{ fontSize: 15, textAlign: "left" }}
              value={uatby}
              onChange={handleUATBy}
            >
              <MenuItem value="">
                <em>Select Name</em>
              </MenuItem>
              {Array.isArray(dropdowndata?.pms) &&
                dropdowndata?.pms.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2} sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            sx={{
              fontSize: 15,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            Migration By
          </Typography>
          <FormControl
            sx={{
              maxWidth: 300,
              minWidth: 300,
              marginTop: 1,
              marginBottom: 1,
            }}
          >
            <Select
              displayEmpty
              size="small"
              sx={{ fontSize: 15, textAlign: "left" }}
              value={migartionby}
              onChange={handleMigrationBy}
            >
              <MenuItem value="">
                <em>Select Name</em>
              </MenuItem>
              {Array.isArray(dropdowndata?.migration_developers) &&
                dropdowndata?.migration_developers.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Typography
        sx={{
          fontSize: 15,
          display: "flex",
          marginTop: "0.5rem",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        Attachments
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "4rem",
          border: "2px dashed #C0C0C0",
          borderRadius: "8px",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "#C0C0C0", color: "black" }}
          onClick={handleFileSelect}
        >
          {fileName ? "Uploaded" : "Choose File"}
        </Button>
        <input
          ref={fileInputRef}
          type="file"
          style={{ display: "none" }}
          accept=".jpg, .jpeg, .zip, .pdf, .xlsx"
          onChange={handleFileChange}
        />
        {fileName && (
          <Typography
            variant="body2"
            sx={{ marginLeft: "0.5rem", color: "#333" }}
          >
            File Uploaded: <strong>{fileName}</strong>
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          marginTop: "1rem",
        }}
      >
        <Button style={{ color: "black" }} onClick={() => setCreate(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          style={{ backgroundColor: "#0160F1", color: "white" }}
          onClick={handleSubmitRequest}
        >
          Create
        </Button>
      </Box>
    </>
  );
};

export default CreateModal;
